import { useEffect, useRef } from 'react'

const DEFAULT_ENGAGEMENT_SCROLL_THRESHOLD = 0.3

function isScrollThresholdReached(threshold: number): boolean {
  if (window.scrollY <= 0) return false

  const total = document.documentElement.scrollHeight
  if (total <= 0) return false

  const scrolled = window.scrollY + window.innerHeight
  return scrolled / total >= threshold
}

export function useScrollEngagementTracking(input: {
  enabled?: boolean
  threshold?: number
  onEngaged: () => void
}) {
  const enabled = input.enabled ?? true
  const threshold = input.threshold ?? DEFAULT_ENGAGEMENT_SCROLL_THRESHOLD
  const engagedRef = useRef(false)
  const onEngagedRef = useRef(input.onEngaged)

  useEffect(() => {
    onEngagedRef.current = input.onEngaged
  }, [input.onEngaged])

  useEffect(() => {
    if (!enabled) return

    const handleScroll = () => {
      if (engagedRef.current) return
      if (!isScrollThresholdReached(threshold)) return

      engagedRef.current = true
      onEngagedRef.current()
      window.removeEventListener('scroll', handleScroll)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [enabled, threshold])
}
